import { Typography } from '@mui/material'

const Typo = (props) => {
  return (
    <Typography variant={props.variant} sx={props.sx && props.sx} color={props.color}>{props.text}</Typography>
  )
}

export default Typo